// extracted by mini-css-extract-plugin
export default {"step":"step-form-item_step__M-GCG","form__wrapper":"step-form-item_form__wrapper__SCzkA","form__item":"step-form-item_form__item__cZQD3","column":"step-form-item_column__A4vNE"};